module.exports = __webpack_public_path__ + "img/goBack1.958ab3f4.png";